import { useIsPermitted } from "@/hooks/useIsPermitted";
import { Button, ButtonProps } from "../ui/button";
import { ROLES } from "@/common/permissions";

export interface ButtonWithPermissionProps extends ButtonProps {
  role?: ROLES;
}

export function ButtonWithPermission({ children, role, ...props }: ButtonWithPermissionProps) {
  const isPermitted = useIsPermitted(role || ROLES.WAITER);

  if (!isPermitted) {
    return null;
  }
  
  return (
    <Button disabled={!isPermitted} {...props}>
      {children}
    </Button>
  );
}
